import { Link } from "wouter";
import { Card } from "../components/Card";
import { PasswordCard } from "./IndstillingerPage";
import styles from "./KontoPage.module.css";

/** Personlige kontoindstillinger for administrative roller, også bogholderen. */
export function KontoPage() {
  return (
    <div className={styles.page}>
      <Card title="Konto og sikkerhed">
        <p>
          Her kan du beskytte din personlige adgang og se, hvilke enheder der
          er logget ind på din konto.
        </p>
        <p>
          <Link href="/enheder">Se og administrér dine enheder</Link>
        </p>
      </Card>
      <PasswordCard />
    </div>
  );
}
